<template>
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 18"
    aria-hidden="true"
  >
    <path
      d="M19.61.18C16-.06 8-.06 4.39.18.49.45 0 2.8 0 9s.48 8.55 4.39 8.82c3.6.24 11.62.24 15.22 0C23.51 17.55 24 15.2 24 9S23.52.45 19.61.18zM9 13V5l8 4z"
    />
  </svg>
</template>
